<div class="component-container flex flex-col md:flex-row flex-wrap justify-between items-center w-full gap-[1rem]">
  <app-search-on-select
    class="input md:w-[25%] md:min-w-[25%] lg:w-[15%] lg:min-w-[15%] w-full flex-grow"
    [parentFormGroup]="form"
    [options]="groupOptions.list"
    (checkForErrors)="checkForErrors($event)"
    [error]="errorMessages['groupId']"
    controlName="groupId"
    label="Group"
    placeholder="Select all that apply"
    type="small"
    (onNextPage)="groupOnNextPage()"
    [enableMultiple]="true"
    [loading]="groupOptions.loading"
    [hasNext]="groupOptions.hasNext"
    filterControlName="searchGroup"
    [enableClearSelection]="true"
    optionsPanelClassName="clients-dropdown"
  />
  <app-dropdown
    (checkForErrors)="checkForErrors($event)"
    [enableClearSelection]="true"
    [enableMultiple]="true"
    [error]="errorMessages['role']"
    [options]="roleFilterList"
    [parentFormGroup]="form"
    class="input md:w-[25%] md:min-w-[25%] lg:w-[15%] lg:min-w-[15%] w-full flex-grow"
    controlName="role"
    label="Role"
    placeholder="Select all that apply"
    type="small"
  />
  <app-dropdown
    class="input md:w-[25%] md:min-w-[25%] lg:w-[15%] lg:min-w-[15%] w-full flex-grow"
    [parentFormGroup]="form"
    (checkForErrors)="checkForErrors($event)"
    [error]="errorMessages['session']"
    [options]="sessionFilterList"
    [enableClearSelection]="true"
    controlName="session"
    label="Sessions"
    placeholder="Select all that apply"
    type="small"
  />
  <app-dropdown
    class="input md:w-[25%] md:min-w-[25%] lg:w-[15%] lg:min-w-[15%] w-full flex-grow"
    [parentFormGroup]="form"
    (checkForErrors)="checkForErrors($event)"
    [error]="errorMessages['status']"
    [options]="statusFilterList"
    [enableMultiple]="true"
    [enableClearSelection]="true"
    controlName="status"
    label="Status"
    placeholder="Select all that apply"
    type="small"
  />

  <div class="vertical hidden md:block"></div>

  <app-text-input
    class="input w-full md:w-[25%] md:min-w-[25%] lg:w-[15%] lg:min-w-[15%] search-input flex-grow"
    [parentFormGroup]="form"
    (checkForErrors)="checkForErrors($event)"
    [error]="errorMessages['searchText']"
    (handleSuffixClick)="apply()"
    suffixIcon="search"
    controlName="searchText"
    label="Search"
    placeholder="Search by name"
    type="small"
    [minLength]="0"
  />

  <div class="vertical hidden md:block"></div>

  <app-primary-button
    type="small"
    class="btn lg:w-[10%] md:w-[10%] w-full"
    (handleClick)="apply()"
    [isDisabled]="!form.dirty"
  >
    Apply
  </app-primary-button>
</div>
